import Grid from "@mui/material/Grid2";
import React from "react";
import ContactTab from "../../../../../../../Shared/ContactTab";
import AddressTab from "../../../../../../../Shared/AddressTab";
import TabPanel from "../../../../../../../Shared/TabPanel";
import useDebugInformation from '../../../../../../../../hooks/useDebugInformation';
import AddressSwitch from "../../../../../../../Shared/AddressSwitch";
import ContactSwitch from "../../../../../../../Shared/ContactSwitch";
import PaymentMethodTab from "../../../../../../../Shared/PaymentMethodTab";
import SideTabs from "./SideTabs";
import SquareTab from "./SquareTab";
import { validateTab } from "@utils/general";
import BusinessSwitchBilling from "../../../../../../../Shared/BusinessSwitchBilling";
import { useAppSelector } from "@store/hooks";

const prefix = "BookingPayment"
const name = "PaymentBillingDetails"

type Props = {
  parent: string
}

const PaymentBillingDetails: React.FC<Props> = ({ parent }) => {
  const BookingPaymentTab = useAppSelector(({ ui }) => ui.BookingPaymentTab)
  const isCustomerAgreed = useAppSelector(({ ui }) => ui.BookingPaymentMethodCardAgreed)
  const bookingCardSecured = useAppSelector(({ ui }) => ui.BookingCardSecured)

  React.useEffect(() => {
    if (bookingCardSecured) {
      validateTab("BookingPayment")
    }
  }, [bookingCardSecured])

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { name, prefix, BookingPaymentTab })
  return (
    <Grid container >
      <SideTabs parent={parent} prefix={`${prefix}Method`} />
      <TabPanel parent={debugName} value={BookingPaymentTab} index={0}  >
        <PaymentMethodTab parent={debugName} prefix={`${prefix}Method`} />
      </TabPanel>
      {isCustomerAgreed && <><TabPanel parent={debugName} value={BookingPaymentTab} index={1} style={{ marginBottom: 12, minHeight: 345 }} >
        <ContactTab parent={name} prefix={`${prefix}Contact`} >
          <ContactSwitch parent={debugName} prefix={`${prefix}Contact`} />
        </ContactTab>
      </TabPanel>
        <TabPanel parent={debugName} value={BookingPaymentTab} index={2} style={{ marginBottom: 12, minHeight: 345 }} >
          <AddressTab parent={debugName} prefix={`${prefix}Address`} >
            <div style={{ display: "flex" }}>
              <BusinessSwitchBilling parent={debugName} prefix={`${prefix}Address`} />
              <AddressSwitch parent={debugName} prefix={`${prefix}Address`} />
            </div>
          </AddressTab>
        </TabPanel>
        <TabPanel parent={debugName} value={BookingPaymentTab} index={3} style={{ marginBottom: 12, minHeight: 345 }} >
          <SquareTab parent={debugName} />
        </TabPanel></>}
    </Grid>
  );
};

export default React.memo(PaymentBillingDetails);
